import FontFaceObserver from 'fontfaceobserver'

const LazyLoadFonts = () => {
  const lato = new FontFaceObserver('Lato')
  const novecento = new FontFaceObserver('Novecento')

  Promise.all([lato.load(), novecento.load()]).then(() => {
    document.documentElement.classList.add('fonts-loaded')
  })
}

export default LazyLoadFonts



// WEBPACK FOOTER //
// ./src/js/modules/LazyLoadFonts.js